var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../lib/nunjucks/nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["icons/chevron-down.html"] = require( "icons/chevron-down.html" );
dependencies["icons/ui-search.html"] = require( "icons/ui-search.html" );
dependencies["icons/ui-close.html"] = require( "icons/ui-close.html" );
dependencies["components/escrowLogo-v2-darkMode.html"] = require( "components/escrowLogo-v2-darkMode.html" );
dependencies["components/escrowLogo-v2.html"] = require( "components/escrowLogo-v2.html" );
dependencies["components/escrowLogo-darkMode.html"] = require( "components/escrowLogo-darkMode.html" );
dependencies["components/escrowLogo.html"] = require( "components/escrowLogo.html" );
dependencies["navigation/v2/startTransactionUpsell.html"] = require( "navigation/v2/startTransactionUpsell.html" );
dependencies["navigation/v2/expandableSearch.html"] = require( "navigation/v2/expandableSearch.html" );




var shim = require("/code/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["escrow_www/templates/navigation/v2/headerLoggedOut.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("icons/chevron-down.html", false, "escrow_www/templates/navigation/v2/headerLoggedOut.html", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("chevronDown")) {
var t_4 = t_1.chevronDown;
} else {
cb(new Error("cannot import 'chevronDown'")); return;
}
context.setVariable("arrowDownIcon", t_4);
env.getTemplate("icons/ui-search.html", false, "escrow_www/templates/navigation/v2/headerLoggedOut.html", false, function(t_6,t_5) {
if(t_6) { cb(t_6); return; }
t_5.getExported(context.getVariables(), frame, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
if(t_5.hasOwnProperty("search")) {
var t_8 = t_5.search;
} else {
cb(new Error("cannot import 'search'")); return;
}
context.setVariable("searchIcon", t_8);
env.getTemplate("icons/ui-close.html", false, "escrow_www/templates/navigation/v2/headerLoggedOut.html", false, function(t_10,t_9) {
if(t_10) { cb(t_10); return; }
t_9.getExported(context.getVariables(), frame, function(t_11,t_9) {
if(t_11) { cb(t_11); return; }
if(t_9.hasOwnProperty("close")) {
var t_12 = t_9.close;
} else {
cb(new Error("cannot import 'close'")); return;
}
context.setVariable("closeIcon", t_12);
if(runtime.contextOrFrameLookup(context, frame, "header_type") == "integrations_landing" || runtime.contextOrFrameLookup(context, frame, "header_type") == "integrations_portal") {
output += "\n  ";
var t_13;
t_13 = (lineno = 5, colno = 27, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".integrations_login"]));
frame.set("login_link", t_13, true);
if(frame.topLevel) {
context.setVariable("login_link", t_13);
}
if(frame.topLevel) {
context.addExport("login_link", t_13);
}
output += "\n  ";
var t_14;
t_14 = (lineno = 6, colno = 28, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".integrations_signup"]));
frame.set("signup_link", t_14, true);
if(frame.topLevel) {
context.setVariable("signup_link", t_14);
}
if(frame.topLevel) {
context.addExport("signup_link", t_14);
}
output += "\n";
;
}
else {
output += "\n  ";
var t_15;
t_15 = (lineno = 8, colno = 27, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".login_page"]));
frame.set("login_link", t_15, true);
if(frame.topLevel) {
context.setVariable("login_link", t_15);
}
if(frame.topLevel) {
context.addExport("login_link", t_15);
}
output += "\n  ";
var t_16;
t_16 = (lineno = 9, colno = 28, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".signup_page"]));
frame.set("signup_link", t_16, true);
if(frame.topLevel) {
context.setVariable("signup_link", t_16);
}
if(frame.topLevel) {
context.addExport("signup_link", t_16);
}
output += "\n";
;
}
output += "\n\n<header class=\"headerV2 ";
if(runtime.contextOrFrameLookup(context, frame, "scrollTop")) {
output += "is-header-scrollTop";
;
}
output += "\" data-sticky-header data-header-logged-out data-header data-theme=\"";
output += runtime.suppressValue(env.getFilter("default").call(context, runtime.contextOrFrameLookup(context, frame, "theme"),"light"), env.opts.autoescape);
output += "\">\n  <div class=\"headerV2-primary headerV2-primary--";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "theme"), env.opts.autoescape);
output += "\">\n    <div class=\"headerV2-container section-container\">\n      <div class=\"headerV2-inner\">\n        <button class=\"headerV2-menuBtn media--available@tablet\" aria-label=\"";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_17 = "";t_17 += "Open Menu";
cb(null, t_17);
;
return t_17;
}
), true && env.opts.autoescape);
output += "\"data-header-menu-toggle>\n          ";
output += runtime.suppressValue((lineno = 17, colno = 24, runtime.callWrap(t_4, "arrowDownIcon", context, [runtime.makeKeywordArgs({"specifier": "headerV2-menuBtn-icon"})])), env.opts.autoescape);
output += "\n        </button>\n        <a href=\"";
output += runtime.suppressValue((lineno = 19, colno = 24, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".index"])), env.opts.autoescape);
output += "\" class=\"headerV2-logo\" title=\"";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_18 = "";t_18 += "Go to home page";
cb(null, t_18);
;
return t_18;
}
), true && env.opts.autoescape);
output += "\">\n          <span class=\"media--available@tablet\">\n            ";
if(runtime.contextOrFrameLookup(context, frame, "theme") == "dark") {
output += "\n              ";
env.getTemplate("components/escrowLogo-v2-darkMode.html", false, "escrow_www/templates/navigation/v2/headerLoggedOut.html", null, function(t_21,t_19) {
if(t_21) { cb(t_21); return; }
t_19.render(context.getVariables(), frame, function(t_22,t_20) {
if(t_22) { cb(t_22); return; }
output += t_20
output += "\n            ";
})});
}
else {
output += "\n              ";
env.getTemplate("components/escrowLogo-v2.html", false, "escrow_www/templates/navigation/v2/headerLoggedOut.html", null, function(t_25,t_23) {
if(t_25) { cb(t_25); return; }
t_23.render(context.getVariables(), frame, function(t_26,t_24) {
if(t_26) { cb(t_26); return; }
output += t_24
output += "\n            ";
})});
}
output += "\n          </span>\n          <span class=\"media--hidden@tablet\">\n            ";
if(runtime.contextOrFrameLookup(context, frame, "theme") == "dark") {
output += "\n              ";
env.getTemplate("components/escrowLogo-darkMode.html", false, "escrow_www/templates/navigation/v2/headerLoggedOut.html", null, function(t_29,t_27) {
if(t_29) { cb(t_29); return; }
t_27.render(context.getVariables(), frame, function(t_30,t_28) {
if(t_30) { cb(t_30); return; }
output += t_28
output += "\n            ";
})});
}
else {
output += "\n              ";
env.getTemplate("components/escrowLogo.html", false, "escrow_www/templates/navigation/v2/headerLoggedOut.html", null, function(t_33,t_31) {
if(t_33) { cb(t_33); return; }
t_31.render(context.getVariables(), frame, function(t_34,t_32) {
if(t_34) { cb(t_34); return; }
output += t_32
output += "\n            ";
})});
}
output += "\n          </span>\n        </a>\n        <nav class=\"headerV2-nav\">\n          <ul class=\"headerV2-primaryNav\">\n            <li class=\"headerV2-primaryNav-item headerV2-primaryNav-upsell media--available@tablet\">\n                <div class=\"headerV2-upsell media--hidden@mobile\">\n                  <div class=\"headerV2-upsell-content\">\n                    <h3 class=\"headerV2-upsell-title\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_35 = "";t_35 += "Start A Transaction With Escrow";
cb(null, t_35);
;
return t_35;
}
), true && env.opts.autoescape);
output += "</h3>\n                  </div>\n                  <div class=\"headerV2-upsell-action\">\n                    <a href=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "signup_link"), env.opts.autoescape);
output += "?loginLocation=transaction-choice\" class=\"btn btn--secondary\" data-e2e-target=\"header-nav-start-transaction\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_36 = "";t_36 += "Get Started Now";
cb(null, t_36);
;
return t_36;
}
), true && env.opts.autoescape);
output += "</a>\n                  </div>\n                </div>\n                <a href=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "signup_link"), env.opts.autoescape);
output += "?loginLocation=transaction-choice\" class=\"btn btn--secondary btn--block media--available@mobile\" data-e2e-target=\"header-nav-start-transaction\">\n                    ";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_37 = "";t_37 += "Start A Transaction";
cb(null, t_37);
;
return t_37;
}
), true && env.opts.autoescape);
output += "\n                </a>\n            </li>\n            <li role=\"tab\" tabindex=\"0\" class=\"headerV2-primaryNav-item\" aria-controls=\"header-consumer-tab\" id=\"header-consumer\"  data-header-nav-item>\n              <span class=\"headerV2-primaryNav-title\">\n                <span class=\"headerV2-primaryNav-text\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_38 = "";t_38 += "Consumer";
cb(null, t_38);
;
return t_38;
}
), true && env.opts.autoescape);
output += "</span>\n                ";
output += runtime.suppressValue((lineno = 53, colno = 30, runtime.callWrap(t_4, "arrowDownIcon", context, [runtime.makeKeywordArgs({"specifier": "headerV2-primaryNav-icon"})])), env.opts.autoescape);
output += "\n              </span>\n              <div class=\"headerV2-subnav\" role=\"tabpanel\" aria-labelledby=\"header-consumer\" id=\"header-consumer-tab\">\n                <div class=\"headerV2-subnav-container\">\n                  <ul class=\"headerV2-subnav-list\">\n                    <li class=\"headerV2-subnav-item\">\n                      <a href=\"";
output += runtime.suppressValue((lineno = 59, colno = 38, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".what-is-escrow"])), env.opts.autoescape);
output += "\" class=\"headerV2-subnav-link\" data-e2e-target=\"header-nav-consumer-get-started\">\n                        <h3 class=\"headerV2-subnav-title\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_39 = "";t_39 += "Learn More";
cb(null, t_39);
;
return t_39;
}
), true && env.opts.autoescape);
output += "</h3>\n                        <p class=\"headerV2-subnav-desc\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_40 = "";t_40 += "How to use Escrow.com";
cb(null, t_40);
;
return t_40;
}
), true && env.opts.autoescape);
output += "</p>\n                      </a>\n                    </li>\n                    <li class=\"headerV2-subnav-item\">\n                      <a href=\"";
output += runtime.suppressValue((lineno = 65, colno = 38, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".why-escrowcom/benefits"])), env.opts.autoescape);
output += "\" class=\"headerV2-subnav-link\" data-e2e-target=\"header-nav-consumer-benefits\">\n                        <h3 class=\"headerV2-subnav-title\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_41 = "";t_41 += "Benefits";
cb(null, t_41);
;
return t_41;
}
), true && env.opts.autoescape);
output += "</h3>\n                        <p class=\"headerV2-subnav-desc\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_42 = "";t_42 += "See the advantages of using Escrow";
cb(null, t_42);
;
return t_42;
}
), true && env.opts.autoescape);
output += "</p>\n                      </a>\n                    </li>\n                    <li class=\"headerV2-subnav-item\">\n                      <a href=\"";
output += runtime.suppressValue((lineno = 71, colno = 38, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".fee-calculator"])), env.opts.autoescape);
output += "\" class=\"headerV2-subnav-link\" data-e2e-target=\"header-nav-consumer-fees\">\n                        <h3 class=\"headerV2-subnav-title\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_43 = "";t_43 += "Fees";
cb(null, t_43);
;
return t_43;
}
), true && env.opts.autoescape);
output += "</h3>\n                        <p class=\"headerV2-subnav-desc\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_44 = "";t_44 += "Low transparent fees";
cb(null, t_44);
;
return t_44;
}
), true && env.opts.autoescape);
output += "</p>\n                      </a>\n                    </li>\n                  </ul>\n                  ";
env.getTemplate("navigation/v2/startTransactionUpsell.html", false, "escrow_www/templates/navigation/v2/headerLoggedOut.html", null, function(t_47,t_45) {
if(t_47) { cb(t_47); return; }
t_45.render(context.getVariables(), frame, function(t_48,t_46) {
if(t_48) { cb(t_48); return; }
output += t_46
output += "\n                </div>\n              </div>\n            </li>\n            <li role=\"tab\" tabindex=\"0\" class=\"headerV2-primaryNav-item\" aria-controls=\"header-broker-tab\" id=\"header-broker\"  data-header-nav-item>\n              <span class=\"headerV2-primaryNav-title\">\n                <span class=\"headerV2-primaryNav-text\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_49 = "";t_49 += "Broker";
cb(null, t_49);
;
return t_49;
}
), true && env.opts.autoescape);
output += "</span>\n                ";
output += runtime.suppressValue((lineno = 84, colno = 30, runtime.callWrap(t_4, "arrowDownIcon", context, [runtime.makeKeywordArgs({"specifier": "headerV2-primaryNav-icon"})])), env.opts.autoescape);
output += "\n              </span>\n              <div class=\"headerV2-subnav\" role=\"tabpanel\" aria-labelledby=\"header-broker\" id=\"header-broker-tab\">\n                <div class=\"headerV2-subnav-container\">\n                  <ul class=\"headerV2-subnav-list\">\n                    <li class=\"headerV2-subnav-item\">\n                      <a href=\"";
output += runtime.suppressValue((lineno = 90, colno = 38, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".what-is-escrow/how-it-works-broker"])), env.opts.autoescape);
output += "\" class=\"headerV2-subnav-link\" data-e2e-target=\"header-nav-broker-get-started\">\n                        <h3 class=\"headerV2-subnav-title\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_50 = "";t_50 += "Learn More";
cb(null, t_50);
;
return t_50;
}
), true && env.opts.autoescape);
output += "</h3>\n                        <p class=\"headerV2-subnav-desc\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_51 = "";t_51 += "Learn how broker Escrow works";
cb(null, t_51);
;
return t_51;
}
), true && env.opts.autoescape);
output += "</p>\n                      </a>\n                    </li>\n                    <li class=\"headerV2-subnav-item\">\n                      <a href=\"";
output += runtime.suppressValue((lineno = 96, colno = 38, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".broker"])), env.opts.autoescape);
output += "\" class=\"headerV2-subnav-link\" data-e2e-target=\"header-nav-broker-become-a-broker\">\n                        <h3 class=\"headerV2-subnav-title\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_52 = "";t_52 += "Become a Broker";
cb(null, t_52);
;
return t_52;
}
), true && env.opts.autoescape);
output += "</h3>\n                        <p class=\"headerV2-subnav-desc\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_53 = "";t_53 += "Act as a trusted third party";
cb(null, t_53);
;
return t_53;
}
), true && env.opts.autoescape);
output += "</p>\n                      </a>\n                    </li>\n                    <li class=\"headerV2-subnav-item\">\n                      <a href=\"";
output += runtime.suppressValue((lineno = 102, colno = 38, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".fee-calculator"])), env.opts.autoescape);
output += "\" class=\"headerV2-subnav-link\" data-e2e-target=\"header-nav-broker-fees\">\n                        <h3 class=\"headerV2-subnav-title\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_54 = "";t_54 += "Fees";
cb(null, t_54);
;
return t_54;
}
), true && env.opts.autoescape);
output += "</h3>\n                        <p class=\"headerV2-subnav-desc\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_55 = "";t_55 += "Low transparent fees";
cb(null, t_55);
;
return t_55;
}
), true && env.opts.autoescape);
output += "</p>\n                      </a>\n                    </li>\n                  </ul>\n                  ";
env.getTemplate("navigation/v2/startTransactionUpsell.html", false, "escrow_www/templates/navigation/v2/headerLoggedOut.html", null, function(t_58,t_56) {
if(t_58) { cb(t_58); return; }
t_56.render(context.getVariables(), frame, function(t_59,t_57) {
if(t_59) { cb(t_59); return; }
output += t_57
output += "\n                </div>\n              </div>\n            </li>\n            <li role=\"tab\" tabindex=\"0\" class=\"headerV2-primaryNav-item\" aria-controls=\"header-business-tab\" id=\"header-business\"  data-header-nav-item>\n              <span class=\"headerV2-primaryNav-title\">\n                <span class=\"headerV2-primaryNav-text\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_60 = "";t_60 += "Business";
cb(null, t_60);
;
return t_60;
}
), true && env.opts.autoescape);
output += "</span>\n                ";
output += runtime.suppressValue((lineno = 115, colno = 30, runtime.callWrap(t_4, "arrowDownIcon", context, [runtime.makeKeywordArgs({"specifier": "headerV2-primaryNav-icon"})])), env.opts.autoescape);
output += "\n              </span>\n              <div class=\"headerV2-subnav\" role=\"tabpanel\" aria-labelledby=\"header-business\" id=\"header-business-tab\">\n                <div class=\"headerV2-subnav-container\">\n                  <ul class=\"headerV2-subnav-list\">\n                    <li class=\"headerV2-subnav-item\">\n                      <a href=\"";
output += runtime.suppressValue((lineno = 121, colno = 38, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".what-is-escrow"])), env.opts.autoescape);
output += "\" class=\"headerV2-subnav-link\" data-e2e-target=\"header-nav-businesss-get-started\">\n                        <h3 class=\"headerV2-subnav-title\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_61 = "";t_61 += "Learn More";
cb(null, t_61);
;
return t_61;
}
), true && env.opts.autoescape);
output += "</h3>\n                        <p class=\"headerV2-subnav-desc\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_62 = "";t_62 += "How Escrow works for your business";
cb(null, t_62);
;
return t_62;
}
), true && env.opts.autoescape);
output += "</p>\n                      </a>\n                    </li>\n                    <li class=\"headerV2-subnav-item\">\n                      <a href=\"";
output += runtime.suppressValue((lineno = 127, colno = 38, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".partners"])), env.opts.autoescape);
output += "\" class=\"headerV2-subnav-link\" data-e2e-target=\"header-nav-businesss-become-a-partner\">\n                        <h3 class=\"headerV2-subnav-title\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_63 = "";t_63 += "Become a Partner";
cb(null, t_63);
;
return t_63;
}
), true && env.opts.autoescape);
output += "</h3>\n                        <p class=\"headerV2-subnav-desc\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_64 = "";t_64 += "Grow your business and revenue";
cb(null, t_64);
;
return t_64;
}
), true && env.opts.autoescape);
output += "</p>\n                      </a>\n                    </li>\n                    <li class=\"headerV2-subnav-item\">\n                      <a href=\"";
output += runtime.suppressValue((lineno = 133, colno = 38, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".why-escrowcom/benefits"])), env.opts.autoescape);
output += "\" class=\"headerV2-subnav-link\" data-e2e-target=\"header-nav-businesss-benefits\">\n                        <h3 class=\"headerV2-subnav-title\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_65 = "";t_65 += "Benefits";
cb(null, t_65);
;
return t_65;
}
), true && env.opts.autoescape);
output += "</h3>\n                        <p class=\"headerV2-subnav-desc\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_66 = "";t_66 += "See the advantages of using Escrow";
cb(null, t_66);
;
return t_66;
}
), true && env.opts.autoescape);
output += "</p>\n                      </a>\n                    </li>\n                    <li class=\"headerV2-subnav-item\">\n                      <a href=\"";
output += runtime.suppressValue((lineno = 139, colno = 38, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".fee-calculator"])), env.opts.autoescape);
output += "\" class=\"headerV2-subnav-link\" data-e2e-target=\"header-nav-help-fees\">\n                        <h3 class=\"headerV2-subnav-title\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_67 = "";t_67 += "Fees";
cb(null, t_67);
;
return t_67;
}
), true && env.opts.autoescape);
output += "</h3>\n                        <p class=\"headerV2-subnav-desc\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_68 = "";t_68 += "Low transparent fees";
cb(null, t_68);
;
return t_68;
}
), true && env.opts.autoescape);
output += "</p>\n                      </a>\n                    </li>\n                    <li class=\"headerV2-subnav-item\">\n                      <a href=\"";
output += runtime.suppressValue((lineno = 145, colno = 38, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".pay"])), env.opts.autoescape);
output += "\" class=\"headerV2-subnav-link\" data-e2e-target=\"header-nav-businesss-escrow-pay\">\n                        <h3 class=\"headerV2-subnav-title\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_69 = "";t_69 += "Escrow Pay";
cb(null, t_69);
;
return t_69;
}
), true && env.opts.autoescape);
output += "</h3>\n                        <p class=\"headerV2-subnav-desc\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_70 = "";t_70 += "Simplest way to add escrow payments";
cb(null, t_70);
;
return t_70;
}
), true && env.opts.autoescape);
output += "</p>\n                      </a>\n                    </li>\n                    <li class=\"headerV2-subnav-item\">\n                      <a href=\"";
output += runtime.suppressValue((lineno = 151, colno = 38, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".offer"])), env.opts.autoescape);
output += "\" class=\"headerV2-subnav-link\" data-e2e-target=\"header-nav-businesss-escrow-offer\">\n                        <h3 class=\"headerV2-subnav-title\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_71 = "";t_71 += "Escrow Offer";
cb(null, t_71);
;
return t_71;
}
), true && env.opts.autoescape);
output += "</h3>\n                        <p class=\"headerV2-subnav-desc\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_72 = "";t_72 += "Allow negotiation for your transactions";
cb(null, t_72);
;
return t_72;
}
), true && env.opts.autoescape);
output += "</p>\n                      </a>\n                    </li>\n                    <li class=\"headerV2-subnav-item\">\n                      <a href=\"";
output += runtime.suppressValue((lineno = 157, colno = 38, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".button_creation"])), env.opts.autoescape);
output += "\" class=\"headerV2-subnav-link\" data-e2e-target=\"header-nav-businesss-escrow-buttons\">\n                        <h3 class=\"headerV2-subnav-title\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_73 = "";t_73 += "Escrow Buttons";
cb(null, t_73);
;
return t_73;
}
), true && env.opts.autoescape);
output += "</h3>\n                        <p class=\"headerV2-subnav-desc\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_74 = "";t_74 += "Create a button for Escrow transaction";
cb(null, t_74);
;
return t_74;
}
), true && env.opts.autoescape);
output += "</p>\n                      </a>\n                    </li>\n                    <li class=\"headerV2-subnav-item\">\n                      <a href=\"";
output += runtime.suppressValue((lineno = 163, colno = 38, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".integrations"])), env.opts.autoescape);
output += "\" class=\"headerV2-subnav-link\" data-e2e-target=\"header-nav-businesss-escrow-api\">\n                        <h3 class=\"headerV2-subnav-title\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_75 = "";t_75 += "Escrow API";
cb(null, t_75);
;
return t_75;
}
), true && env.opts.autoescape);
output += "</h3>\n                        <p class=\"headerV2-subnav-desc\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_76 = "";t_76 += "Get all benefits of Escrow via API";
cb(null, t_76);
;
return t_76;
}
), true && env.opts.autoescape);
output += "</p>\n                      </a>\n                    </li>\n                  </ul>\n                  ";
env.getTemplate("navigation/v2/startTransactionUpsell.html", false, "escrow_www/templates/navigation/v2/headerLoggedOut.html", null, function(t_79,t_77) {
if(t_79) { cb(t_79); return; }
t_77.render(context.getVariables(), frame, function(t_80,t_78) {
if(t_80) { cb(t_80); return; }
output += t_78
output += "\n                </div>\n              </div>\n            </li>\n            <li role=\"tab\" tabindex=\"0\" class=\"headerV2-primaryNav-item\" aria-controls=\"header-developer-tab\" id=\"header-developer\" data-header-nav-item>\n              <span class=\"headerV2-primaryNav-title\">\n                <span class=\"headerV2-primaryNav-text\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_81 = "";t_81 += "Developer";
cb(null, t_81);
;
return t_81;
}
), true && env.opts.autoescape);
output += "</span>\n                ";
output += runtime.suppressValue((lineno = 176, colno = 30, runtime.callWrap(t_4, "arrowDownIcon", context, [runtime.makeKeywordArgs({"specifier": "headerV2-primaryNav-icon"})])), env.opts.autoescape);
output += "\n              </span>\n              <div class=\"headerV2-subnav\" role=\"tabpanel\" aria-labelledby=\"header-developer\" id=\"header-developer-tab\">\n                <div class=\"headerV2-subnav-container\">\n                  <ul class=\"headerV2-subnav-list\">\n                    <li class=\"headerV2-subnav-item\">\n                      <a href=\"";
output += runtime.suppressValue((lineno = 182, colno = 38, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".integrations"])), env.opts.autoescape);
output += "\" class=\"headerV2-subnav-link\" data-e2e-target=\"header-nav-developer-api-integration\">\n                        <h3 class=\"headerV2-subnav-title\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_82 = "";t_82 += "API Integration";
cb(null, t_82);
;
return t_82;
}
), true && env.opts.autoescape);
output += "</h3>\n                        <p class=\"headerV2-subnav-desc\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_83 = "";t_83 += "Learn about Escrow API";
cb(null, t_83);
;
return t_83;
}
), true && env.opts.autoescape);
output += "</p>\n                      </a>\n                    </li>\n                    <li class=\"headerV2-subnav-item\">\n                      <a href=\"";
output += runtime.suppressValue((lineno = 188, colno = 38, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".api_guide_basics"])), env.opts.autoescape);
output += "\" class=\"headerV2-subnav-link\" data-e2e-target=\"header-nav-developer-api-documentation\">\n                        <h3 class=\"headerV2-subnav-title\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_84 = "";t_84 += "API Documentation";
cb(null, t_84);
;
return t_84;
}
), true && env.opts.autoescape);
output += "</h3>\n                        <p class=\"headerV2-subnav-desc\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_85 = "";t_85 += "Built by developers for developers";
cb(null, t_85);
;
return t_85;
}
), true && env.opts.autoescape);
output += "</p>\n                      </a>\n                    </li>\n                    <li class=\"headerV2-subnav-item\">\n                      <a href=\"";
output += runtime.suppressValue((lineno = 194, colno = 38, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".pay"])), env.opts.autoescape);
output += "\" class=\"headerV2-subnav-link\" data-e2e-target=\"header-nav-developer-escrow-pay\">\n                        <h3 class=\"headerV2-subnav-title\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_86 = "";t_86 += "Escrow Pay";
cb(null, t_86);
;
return t_86;
}
), true && env.opts.autoescape);
output += "</h3>\n                        <p class=\"headerV2-subnav-desc\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_87 = "";t_87 += "Escrow payment with one API call";
cb(null, t_87);
;
return t_87;
}
), true && env.opts.autoescape);
output += "</p>\n                      </a>\n                    </li>\n                    <li class=\"headerV2-subnav-item\">\n                      <a href=\"";
output += runtime.suppressValue((lineno = 200, colno = 38, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".offer"])), env.opts.autoescape);
output += "\" class=\"headerV2-subnav-link\" data-e2e-target=\"header-nav-developer-escrow-offer\">\n                        <h3 class=\"headerV2-subnav-title\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_88 = "";t_88 += "Escrow Offer";
cb(null, t_88);
;
return t_88;
}
), true && env.opts.autoescape);
output += "</h3>\n                        <p class=\"headerV2-subnav-desc\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_89 = "";t_89 += "Receive offers via API";
cb(null, t_89);
;
return t_89;
}
), true && env.opts.autoescape);
output += "</p>\n                      </a>\n                    </li>\n                    <li class=\"headerV2-subnav-item\">\n                      <a href=\"";
output += runtime.suppressValue((lineno = 206, colno = 38, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".button_creation"])), env.opts.autoescape);
output += "\" class=\"headerV2-subnav-link\" data-e2e-target=\"header-nav-developer-escrow-buttons\">\n                        <h3 class=\"headerV2-subnav-title\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_90 = "";t_90 += "Escrow Buttons";
cb(null, t_90);
;
return t_90;
}
), true && env.opts.autoescape);
output += "</h3>\n                        <p class=\"headerV2-subnav-desc\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_91 = "";t_91 += "Add Escrow Buttons to your website";
cb(null, t_91);
;
return t_91;
}
), true && env.opts.autoescape);
output += "</p>\n                      </a>\n                    </li>\n                  </ul>\n                  ";
env.getTemplate("navigation/v2/startTransactionUpsell.html", false, "escrow_www/templates/navigation/v2/headerLoggedOut.html", null, function(t_94,t_92) {
if(t_94) { cb(t_94); return; }
t_92.render(context.getVariables(), frame, function(t_95,t_93) {
if(t_95) { cb(t_95); return; }
output += t_93
output += "\n                </div>\n              </div>\n            </li>\n            <li role=\"tab\" tabindex=\"0\" class=\"headerV2-primaryNav-item\" aria-controls=\"header-help-tab\" id=\"header-help\" data-header-nav-item>\n              <span class=\"headerV2-primaryNav-title\">\n                <span class=\"headerV2-primaryNav-text\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_96 = "";t_96 += "Help";
cb(null, t_96);
;
return t_96;
}
), true && env.opts.autoescape);
output += "</span>\n                ";
output += runtime.suppressValue((lineno = 219, colno = 30, runtime.callWrap(t_4, "arrowDownIcon", context, [runtime.makeKeywordArgs({"specifier": "headerV2-primaryNav-icon"})])), env.opts.autoescape);
output += "\n              </span>\n              <div class=\"headerV2-subnav\" role=\"tabpanel\" aria-labelledby=\"header-help\" id=\"header-help-tab\">\n                <div class=\"headerV2-subnav-container\">\n                  <ul class=\"headerV2-subnav-list\">\n                    <li class=\"headerV2-subnav-item\">\n                      <a href=\"";
output += runtime.suppressValue((lineno = 225, colno = 38, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".what-is-escrow"])), env.opts.autoescape);
output += "\" class=\"headerV2-subnav-link\" data-e2e-target=\"header-nav-help-what-is-escrow\">\n                        <h3 class=\"headerV2-subnav-title\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_97 = "";t_97 += "What is Escrow? ";
cb(null, t_97);
;
return t_97;
}
), true && env.opts.autoescape);
output += "</h3>\n                        <p class=\"headerV2-subnav-desc\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_98 = "";t_98 += "Learn how Escrow.com works";
cb(null, t_98);
;
return t_98;
}
), true && env.opts.autoescape);
output += "</p>\n                      </a>\n                    </li>\n                    <li class=\"headerV2-subnav-item\">\n                      <a href=\"";
output += runtime.suppressValue((lineno = 231, colno = 38, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".fee-calculator"])), env.opts.autoescape);
output += "\" class=\"headerV2-subnav-link\" data-e2e-target=\"header-nav-help-fees\">\n                        <h3 class=\"headerV2-subnav-title\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_99 = "";t_99 += "Fees";
cb(null, t_99);
;
return t_99;
}
), true && env.opts.autoescape);
output += "</h3>\n                        <p class=\"headerV2-subnav-desc\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_100 = "";t_100 += "Low transparent fees";
cb(null, t_100);
;
return t_100;
}
), true && env.opts.autoescape);
output += "</p>\n                      </a>\n                    </li>\n                    <li class=\"headerV2-subnav-item\">\n                      <a href=\"";
output += runtime.suppressValue((lineno = 237, colno = 38, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".contact-us"])), env.opts.autoescape);
output += "\" class=\"headerV2-subnav-link\" data-e2e-target=\"header-nav-help-contact-us\">\n                        <h3 class=\"headerV2-subnav-title\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_101 = "";t_101 += "Contact Us";
cb(null, t_101);
;
return t_101;
}
), true && env.opts.autoescape);
output += "</h3>\n                        <p class=\"headerV2-subnav-desc\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_102 = "";t_102 += "Get in touch with us";
cb(null, t_102);
;
return t_102;
}
), true && env.opts.autoescape);
output += "</p>\n                      </a>\n                    </li>\n                    <li class=\"headerV2-subnav-item\">\n                      <a href=\"tel:";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "support_phone_number"), env.opts.autoescape);
output += "\" class=\"headerV2-subnav-link\" data-e2e-target=\"header-nav-help-call-us\">\n                        <h3 class=\"headerV2-subnav-title\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_103 = "";t_103 += "Call Us";
cb(null, t_103);
;
return t_103;
}
), true && env.opts.autoescape);
output += "</h3>\n                        <p class=\"headerV2-subnav-desc\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "support_phone_label"), env.opts.autoescape);
output += "</p>\n                      </a>\n                    </li>\n                    <li class=\"headerV2-subnav-item\">\n                      <a href=\"";
output += runtime.suppressValue((lineno = 249, colno = 38, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".helpdesk"])), env.opts.autoescape);
output += "\" class=\"headerV2-subnav-link\" data-e2e-target=\"header-nav-help-help-desk\">\n                        <h3 class=\"headerV2-subnav-title\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_104 = "";t_104 += "Help Desk";
cb(null, t_104);
;
return t_104;
}
), true && env.opts.autoescape);
output += "</h3>\n                        <p class=\"headerV2-subnav-desc\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_105 = "";t_105 += "Find answers to FAQs";
cb(null, t_105);
;
return t_105;
}
), true && env.opts.autoescape);
output += "</p>\n                      </a>\n                    </li>\n                    <li class=\"headerV2-subnav-item\">\n                      <a href=\"";
output += runtime.suppressValue((lineno = 255, colno = 38, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url_for"), "url_for", context, [".about-us"])), env.opts.autoescape);
output += "\" class=\"headerV2-subnav-link\" data-e2e-target=\"header-nav-help-about-us\">\n                        <h3 class=\"headerV2-subnav-title\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_106 = "";t_106 += "About Us";
cb(null, t_106);
;
return t_106;
}
), true && env.opts.autoescape);
output += "</h3>\n                        <p class=\"headerV2-subnav-desc\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_107 = "";t_107 += "Learn about our company";
cb(null, t_107);
;
return t_107;
}
), true && env.opts.autoescape);
output += "</p>\n                      </a>\n                    </li>\n                    <li class=\"headerV2-subnav-item media--available@mobile\">\n                      <a href=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "login_link"), env.opts.autoescape);
output += "\" class=\"headerV2-subnav-link\" data-e2e-target=\"header-nav-help-mobile-login\">\n                        <h3 class=\"headerV2-subnav-title\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_108 = "";t_108 += "Login";
cb(null, t_108);
;
return t_108;
}
), true && env.opts.autoescape);
output += "</h3>\n                      </a>\n                    </li>\n                    <li class=\"headerV2-subnav-item media--available@mobile\">\n                      <a href=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "signup_link"), env.opts.autoescape);
output += "\" class=\"headerV2-subnav-link\">\n                        <h3 class=\"headerV2-subnav-title\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_109 = "";t_109 += "Signup";
cb(null, t_109);
;
return t_109;
}
), true && env.opts.autoescape);
output += " &#8594;</h3>\n                      </a>\n                    </li>\n                  </ul>\n                  ";
env.getTemplate("navigation/v2/startTransactionUpsell.html", false, "escrow_www/templates/navigation/v2/headerLoggedOut.html", null, function(t_112,t_110) {
if(t_112) { cb(t_112); return; }
t_110.render(context.getVariables(), frame, function(t_113,t_111) {
if(t_113) { cb(t_113); return; }
output += t_111
output += "\n                </div>\n              </div>\n            </li>\n          </ul>\n          ";
if(!runtime.contextOrFrameLookup(context, frame, "disable_navbar_search")) {
output += "\n          <div class=\"headerV2-search media--hidden@mobile\">\n            ";
env.getTemplate("navigation/v2/expandableSearch.html", false, "escrow_www/templates/navigation/v2/headerLoggedOut.html", null, function(t_116,t_114) {
if(t_116) { cb(t_116); return; }
t_114.render(context.getVariables(), frame, function(t_117,t_115) {
if(t_117) { cb(t_117); return; }
output += t_115
output += "\n          </div>\n          ";
})});
}
output += "\n          <ul class=\"headerV2-authNav\">\n            <li class=\"headerV2-authNav-item\">\n              <a href=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "login_link"), env.opts.autoescape);
output += "\" class=\"headerV2-authNav-link\" data-e2e-target=\"header-nav-login\">\n                <span class=\"headerV2-authNav-text\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_118 = "";t_118 += "Login";
cb(null, t_118);
;
return t_118;
}
), true && env.opts.autoescape);
output += "</span>\n              </a>\n            </li>\n            <li class=\"headerV2-authNav-item\">\n              <a href=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "signup_link"), env.opts.autoescape);
output += "\" class=\"headerV2-authNav-link\" data-e2e-target=\"header-nav-signup\">\n                <span class=\"headerV2-authNav-text\">";
output += runtime.suppressValue(env.getExtension("TranslationExtension")["run"](context,function(cb) {
if(!cb) { cb = function(err) { if(err) { throw err; }}}
var t_119 = "";t_119 += "Signup";
cb(null, t_119);
;
return t_119;
}
), true && env.opts.autoescape);
output += " &#8594;</span>\n              </a>\n            </li>\n          </ul>\n        </nav>\n      </div>\n    </div>\n  </div>\n</header>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})})})})})})})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["escrow_www/templates/navigation/v2/headerLoggedOut.html"] , dependencies)